import { render, staticRenderFns } from "./overlay-spinner.vue?vue&type=template&id=26544636&"
import script from "./overlay-spinner.vue?vue&type=script&lang=js&"
export * from "./overlay-spinner.vue?vue&type=script&lang=js&"
import style0 from "./overlay-spinner.vue?vue&type=style&index=0&id=26544636&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports